import Qualifiers from "sections/preferences/qualifier";

const ManageQualifiers = () => {
  return (
    <Qualifiers />
  );
};

export default ManageQualifiers;
